import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
import { parseUrl } from 'hub-http/helpers/url';
import { getLocalizedHubSpotUrl } from 'marketplace-ui-common/utils/urls';
export function getConnectedAppsUrl() {
  const base = getFullUrl('app');
  return `${base}/integrations-settings/${PortalIdParser.get()}/installed`;
}
export const getDataSyncProductUrl = (lang = 'en') => `${getLocalizedHubSpotUrl(lang)}/products/data-sync`;
export const getFormattedUrl = href => {
  if (!href) return '';
  const {
    protocol
  } = parseUrl(href);
  return !protocol ? `http://${href}` : href;
};